module.exports = __webpack_public_path__ + "static/pic04-ec2914495c7ea755ea3d319cc0f04632.jpg";